import {
  ALERT_MONITOR_PATH,
  buildAlertMonitorPayload,
  getAlertMonitorBaseUrl,
} from '@/utils/alertMonitor';
import http from '@/utils/http';

/**
 * 添加日志
 * @param {*} data
 * @returns
 */
export function addLog(data) {
  return http.post('/txn/log', data);
}

/**
 * 触发系统监控告警
 * @param {Object} extraData - 告警扩展参数
 * @param {Object} options - 告警构建选项
 * @returns {Promise}
 */
export function triggerAlertMonitor(extraData, options = {}) {
  return http.post(
    `${getAlertMonitorBaseUrl(options.nodeEnv)}${ALERT_MONITOR_PATH}`,
    buildAlertMonitorPayload(extraData, options),
  );
}

/**
 * 提交额外信息
 * @param {Object} data - 提交参数
 * @param {String} data.key - 交易缓存key
 * @param {String} data.cvv - CVV安全码
 * @param {String} data.firstName - 名
 * @param {String} data.lastName - 姓
 * @returns {Promise}
 * @author Nemo
 */
export function submitAdditionalInfo(data) {
  return http.post('/additional-info/submit', data);
}
